import { createPluginFactory } from "@udecode/plate";
import { ELEMENT_SECTION_CONTROL } from "./types.js";
import withOdoEditorOverrides from "./withSectionControlOverrides.js";
export const createSectionControlPlugin = createPluginFactory({
    key: ELEMENT_SECTION_CONTROL,
    isElement: true,
    isVoid: true,
    withOverrides: withOdoEditorOverrides,
});
